import { useDeviceFlowAuthStore } from './DeviceFlowAuth';
import { useAuthStore } from './stores';

export interface FetcherError extends Error {
    info?: unknown;
    status?: number;
}

function resolveGnssBaseUrl(): string {
    const host = process.env.EXPO_PUBLIC_SDR_WS_HOST;
    if (!host || host.length === 0) {
        return '';
    }

    if (host.startsWith('http://') || host.startsWith('https://')) {
        return host;
    }

    return `https://${host}`;
}

export default async function OrvalGnssFetcher<T>(route: string, options: RequestInit): Promise<T> {
    const cloak = useAuthStore.getState().keyCloak;

    let token;
    if (!cloak) {
        token = await useDeviceFlowAuthStore.getState().updateToken();
    } else {
        await cloak.updateToken(5);
        if (!cloak.token) {
            throw new Error('Unauthorized');
        }
        token = cloak.token;
    }

    const headers = new Headers(options.headers);

    if (headers.get('authorization') !== 'undefined') {
        headers.append('Authorization', `Bearer ${token}`);
    }

    if (headers.get('Content-Type') === 'undefined') {
        headers.delete('Content-Type');
    }

    const baseUrl = resolveGnssBaseUrl();
    const response = await fetch(`${baseUrl}${route}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        const error: FetcherError = new Error('An error occurred while fetching the data.');
        try {
            error.info = await response.json();
        } catch {
            error.info = await response.text();
        }
        error.status = response.status;
        throw error;
    }

    if (response.status === 204) {
        return {} as T;
    }

    try {
        return (await response.json()) as T;
    } catch {
        throw new Error('An error occurred while parsing the response.');
    }
}
